// Static content for the landing page sections. Kept out of the components so
// copy and ordering live in one place and the UI stays presentational.

export const NAV_ITEMS = [
  { label: 'Features', id: 'features-section' },
  { label: 'How It Works', id: 'how-it-works-section' },
  { label: 'Experience', id: 'customer-section' },
  { label: 'Pricing', id: 'pricing-section' },
];

export const HOW_IT_WORKS_STEPS = [
  {
    step: '01',
    icon: 'QrCode',
    title: 'Scan QR Code',
    description:
      'Guests scan the unique QR code on their table to instantly open your digital menu. No app download.',
  },
  {
    step: '02',
    icon: 'PhoneIphone',
    title: 'Browse & Order',
    description:
      'Customers explore the menu, customize items with option groups, and order straight from their phones.',
  },
  {
    step: '03',
    icon: 'LocalDining',
    title: 'Pay Online',
    description:
      'Secure cash or GCash checkout completes the order instantly. No waiting for the check.',
  },
  {
    step: '04',
    icon: 'CheckCircle',
    title: 'Track & Serve',
    description:
      'Orders hit your dashboard in real time. Track preparation, watch analytics, and serve with confidence.',
  },
];

export const PLATFORM_FEATURES = [
  {
    icon: 'MenuBook',
    title: 'Digital Menu Builder',
    description:
      'Rich menus with categories, item images, option groups for sizes and add-ons, featured items, and drag-and-drop reordering.',
  },
  {
    icon: 'TableBar',
    title: 'QR Code Table System',
    description:
      'Auto-generate a unique QR code for every table. Manage availability and toggle tables on the fly.',
  },
  {
    icon: 'Dashboard',
    title: 'Smart Order Management',
    description:
      'A Kanban board for live order flow from pending to preparing to completed, plus a kitchen display and full history.',
  },
  {
    icon: 'Payment',
    title: 'Integrated Payments',
    description:
      'Accept cash or GCash with automatic receipt verification, tax and service charges, and flexible discounts.',
  },
  {
    icon: 'Groups',
    title: 'Team Collaboration',
    description:
      'Invite staff by email with role-based access for Owners, Managers, and Staff, and granular per-action permissions.',
  },
  {
    icon: 'BarChart',
    title: 'Analytics & Insights',
    description:
      'Track revenue trends, surface your most popular items, review order stats, and generate date-range reports.',
  },
];

export const EXPERIENCE_STEPS = [
  {
    icon: 'QrCode',
    title: 'Scan & Browse',
    description:
      'Scan the QR code and instantly see your full digital menu on any phone. No app download needed.',
  },
  {
    icon: 'TouchApp',
    title: 'Customize & Order',
    description:
      'Pick items, choose sizes and add-ons, add special instructions, and place the order with a single tap.',
  },
  {
    icon: 'Payment',
    title: 'Pay Instantly',
    description:
      'Choose cash or pay with GCash and upload a receipt. Tax and service charges are calculated automatically.',
  },
  {
    icon: 'NotificationsActive',
    title: 'Track in Real-Time',
    description:
      'Follow order status live from pending to preparing to completed. Guests always know when food is ready.',
  },
];

export const DASHBOARD_STATS = [
  { value: '85%', label: 'Faster Service' },
  { value: '92%', label: 'Customer Satisfaction' },
  { value: '60%', label: 'Less Wait Time' },
  { value: '3x', label: 'Faster Order Processing' },
];

export const DASHBOARD_TAGS = ['Kanban Board', 'Kitchen Display', 'Order History', 'Live Notifications'];

export const WHY_BENEFITS = [
  {
    icon: 'Devices',
    title: 'No App Download',
    description: 'Works instantly in any mobile browser. Customers just scan and go.',
  },
  {
    icon: 'PhoneIphone',
    title: 'Works on Any Phone',
    description: 'Compatible with all smartphones: iOS, Android, any browser.',
  },
  {
    icon: 'Bolt',
    title: 'Setup in Minutes',
    description: 'Create your menu, generate QR codes, and start taking orders today.',
  },
  {
    icon: 'Language',
    title: 'Multi-Currency',
    description: 'Support for multiple currencies with automatic locale detection.',
  },
  {
    icon: 'ShoppingCart',
    title: 'Dine-In & Takeout',
    description: 'Support both dine-in QR ordering and takeout orders from one platform.',
  },
  {
    icon: 'Star',
    title: 'Custom Branding',
    description: 'Personalize your menu page with your logo, colors, and cover photos.',
  },
];

export const TESTIMONIAL = {
  quote:
    "merchQRy's QR ordering system is a game-changer. Customers love scanning, ordering, and paying from their table. Our order processing time dropped by 60%.",
  author: 'Sarah Johnson, Restaurant Owner',
};

export const PRICING_PLANS = [
  {
    badge: 'START HERE',
    name: 'Free Trial',
    price: '₱0',
    period: '/14 days',
    blurb: 'Full access, no credit card required.',
    cta: 'Start Free Trial',
    featured: false,
    features: [
      'All features unlocked',
      'Unlimited menu items',
      'Unlimited tables',
      'Unlimited staff users',
      'Order management',
      'Table QR codes',
      'Analytics dashboard',
      'No credit card needed',
    ],
  },
  {
    badge: 'FULL PLAN',
    name: 'merchQRy',
    price: '₱2,999',
    period: '/month',
    blurb: 'Unlimited everything after your trial.',
    cta: 'Subscribe Now',
    featured: true,
    features: [
      'Everything in Free Trial',
      'Cash & GCash payments',
      'Advanced theming',
      'Analytics (unlimited retention)',
      'Email & SMS notifications',
      'Multi-currency support',
      'Priority support',
      'API access',
    ],
  },
];

export const FOOTER_SOCIALS = ['Facebook', 'Instagram', 'TikTok'];
export const SUPPORT_EMAIL = 'support@merchqry.com';
